/* eslint-disable react/no-unescaped-entities */
import { LIST_TYPE } from "@/shared/types/atoms.types";
import Link from "next/link";
import React from "react";
import ListSection from "../atoms/ListSection";
import TermsParagraph from "../atoms/TermsParagraph";

interface ReferralsListProps {}

const ReferralsList: React.FC<ReferralsListProps> = () => {
  return (
    <div>
      <ListSection
        listIndex="2.1"
        title="Qualified Referrals:"
        listType={LIST_TYPE.LIST2}
      />

      <ListSection
        listIndex="(a)"
        listType={LIST_TYPE.LIST3}
        description={
          <TermsParagraph>
            The Referral Link when accessed will redirect the person accessing
            the same to Graphy’s Creator (as identified in the Platform Terms)
            signup page at <Link href="/">https://graphy.com/</Link>. So, once a
            person registers on the Platform as a Creator by clicking on/through
            Your Referral Link, such person shall be considered as a{" "}
            <b>“Referred User”</b> made by You. When a Referred User has
            successfully purchased a subscription plan on the Platform within 90
            (ninety) days of registering as a Creator on the Platform, such
            Referred User shall be deemed as Your “Qualified Referral”;
            determination of <b>“Qualified Referral”</b> shall also be subject
            to any terms made available during Your Affiliate signup or
            otherwise on the Platform or as communicated to You by Graphy in
            writing (emails included).
          </TermsParagraph>
        }
      />

      <ListSection
        listIndex="(b)"
        listType={LIST_TYPE.LIST3}
        description={
          <TermsParagraph>
            Please note that Referral Links are unique to each Affiliate, and we
            use cookie-based tracking to identify Your Qualified Referrals which
            is enabled through the Referral Links. Our cookies are valid for
            sixty (60) days and a Qualified Referral is attributed to You on a
            last click basis, which means clicking the Referral Link before
            signing up will overwrite any other affiliate cookie currently in
            the system. Also, deleting cookies after clicking the Referral Link
            (but before signing-up or paying-up) disables tracking and
            monitoring these clicks and any sale they may lead to.
            <br />
            <br />
            <b>For example:</b> If Ram clicked on the Referral Link made
            available on Affiliate A’s website, but then failed to register as a
            Creator on the Platform and later, Ram clicks on another Referral
            Link made available on Affiliate B’s website, registers himself on
            the Platform as a Creator, then Ram shall be considered as Affiliate
            B’s Referred User since this was the most recent cookie to get
            tracked by our system, and Affiliate B shall be entitled to Referral
            Rewards (defined below) when Ram ‘successfully purchases a
            subscription plan on the Platform’ (as explained below).
          </TermsParagraph>
        }
      />

      <ListSection
        listIndex="2.2."
        title="A “Qualified Referral” does NOT include the following:"
        listType={LIST_TYPE.LIST2}
      />

      <ListSection
        listIndex="(a)"
        listType={LIST_TYPE.LIST3}
        description={
          <TermsParagraph>
            Self-Referrals shall not be deemed as a Qualified Referral and
            Referral Rewards are not valid or payable for Self-Referrals. So, if
            Your personal/company details, including but not limited to, last
            name, email address, IP address or website details, are the same as
            Your Qualified Referral(s), then such referral will be deemed as a{" "}
            <b>“Self-Referral”</b>. Graphy, in its sole discretion, will
            determine the classification of any referral as a{" "}
            <b>“Self-Referral”</b>.
          </TermsParagraph>
        }
      />

      <ListSection
        listIndex="(b)"
        listType={LIST_TYPE.LIST3}
        description="Referrals made to any existing Graphy Creators shall not be deemed as Qualified Referrals; only a new user registering on the Platform using Your Referral Link shall be considered as Your Qualified Referral. "
      />

      <ListSection
        listIndex="(c)"
        listType={LIST_TYPE.LIST3}
        description="If a Referred User initiates cancellation or refund of the subscription on the Platform within 30 (thirty) days from the date of purchase of the subscription on the Platform, then such Referred User shall not be deemed as a Qualified Referral, and You shall not be entitled to any Referral Rewards in respect of such Referred User. "
      />

      <ListSection
        listIndex="(d)"
        listType={LIST_TYPE.LIST3}
        description="No referral by You shall be considered as a Qualified Referral, if Graphy suspects any fraudulent activity by You to increase Your Qualified Referrals, including without limitation, the use of any software that generates real and fictitious information, multiple accounts from the same Referred Users, or any activity that does not comply with the Affiliate Terms and/or the Platform Terms. In these cases, Graphy shall also have the right to terminate Affiliate’s account and access to the Platform at its sole discretion. "
      />

      <ListSection
        listIndex="(e)"
        listType={LIST_TYPE.LIST3}
        description="Where a Referred User receives from or was offered coupons, refunds, credits or discounts by You to purchase a subscription plan on the Platform and such offering was a not authorised by Graphy, then such purchase by the Referred User shall not amount to a Qualified Referral."
      />

      <ListSection
        listIndex="(f)"
        listType={LIST_TYPE.LIST3}
        description="If it is found by Graphy that You have adopted marketing practices in contravention to these Affiliate Terms or that we deem to be unethical or are likely to attract fraudulent signups, then such Referred Users shall not be deemed as Qualified Referrals."
      />

      <ListSection
        listIndex="(g)"
        listType={LIST_TYPE.LIST3}
        description="Any referral that is deemed to be in contravention of these Affiliate Terms, Platform Terms and/or any other terms as communicated to You by Graphy in writing (emails included) at the sole discretion of Graphy, shall not be deemed as a Qualified Referral."
      />
    </div>
  );
};

ReferralsList.displayName = "ReferralsList";

export default ReferralsList;
